import React, { Component } from 'react';
import ActiveUser from "./ActiveUser";
import "../landingPage/login.css"
import platoLogo from "../../images/brandImages/plato-logo-footer.png";
import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile,
} from "react-device-detect";
class Footer extends Component {
    componentDidMount() {
        ActiveUser();
    }

    render() {
        return (
            <div>
                {/* <BrowserView> */}
                    <footer>
                        <div className="main-heading">
                            <div className='footer-logo'>
                                <img className='footer-logo-image' src={platoLogo} alt='SprinkleZone Logo'></img>
                            </div>
                            <div className="footer-text">
                                <span>Copyright © 2026 Harbinger SprinkleZone. All rights reserved.</span>
                            </div>
                        </div>
                    </footer>
                {/* </BrowserView>
                <MobileView>
                </MobileView> */}
            </div>
        );
    }
}

export default Footer;
